import { useState, useEffect } from "react";

function useInViewport(ref) {
  const [inViewport, setInViewport] = useState(false);

  useEffect(() => {
    const bounding = ref.current && ref.current.getBoundingClientRect();

    if (bounding) {
      const visible = bounding.top > 0 && bounding.left > 0;
      visible && setInViewport(true);
    }
  });

  return inViewport;
}

export default useInViewport;
